import { render, staticRenderFns } from "./ProccessView.vue?vue&type=template&id=3cead180"
import script from "./ProccessView.vue?vue&type=script&lang=js"
export * from "./ProccessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports